const TestGroupStatus = Object.freeze({
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    PASSED: 'passed',
    FAILED: 'failed',
    ABORTED: 'aborted',
});

module.exports = { TestGroupStatus };